import { type Editor, Extension } from '@tiptap/core';
import { Plugin, PluginKey, TextSelection } from '@tiptap/pm/state';

export const EditorFixes = Extension.create({
  name: 'editorFixes',
  addKeyboardShortcuts() {
    return {
      'Mod-a': ({ editor }) => editor.isEmpty,
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('fixEmptySelection'),
        appendTransaction(transactions, _, newState) {
          if (!transactions.some((tr) => tr.docChanged)) {
            return null;
          }

          const isDocEmpty =
            newState.doc.textContent.length === 0 &&
            newState.doc.childCount <= 1 &&
            newState.doc.content.size <= 2;

          if (isDocEmpty && !newState.selection.empty) {
            return newState.tr.setSelection(TextSelection.atStart(newState.doc));
          }

          return null;
        },
      }),
    ];
  },
});

export const isMarkActive = (editor: Editor, markName: string) => {
  if (editor.state.selection.empty) {
    const marks = editor.state.storedMarks || editor.state.selection.$from.marks();

    return marks.some((mark) => mark.type.name === markName);
  }

  return editor.isActive(markName);
};
